import { preInsert, preRemove, preSave } from '@/rxdb/defaultHooks';
import defaultReplication from '@/rxdb/defaultReplication';

export const invoiceReviews = {
    schema: {
        title: 'invoiceReviews schema',
        version: 0,
        description: 'describes a invoiceReviews',
        primaryKey: 'id',
        type: 'object',
        properties: {
            id: { type: 'string', final: true, maxLength: 40 },
            projectId: { type: ['string', 'null'] },
            invoiceId: { type: ['string', 'null'] },
            emitterId: { type: ['string', 'null'] },

            comment: { type: ['string', 'null'] },
            conclusion: { type: ['string', 'null'] },
            emissionDate: { type: ['string', 'null'] },
            emissionDueDate: { type: ['string', 'null'] },

            createdAt: { type: ['string', 'null'] },
            updatedAt: { type: ['string', 'null'] },
            deletedAt: { type: ['string', 'null'] },
            createdBy: { type: ['string', 'null'] },
            updatedBy: { type: ['string', 'null'] },
            deletedBy: { type: ['string', 'null'] },
            rootVersion: { type: 'string' },
        },
    },
    options: {
        onCollectionCreated(projectId, rxCollection) {
            rxCollection.replicationState = defaultReplication(rxCollection, projectId);
            rxCollection.preRemove(preRemove, false);
            rxCollection.preInsert(preInsert, false);
            rxCollection.preSave(preSave, false);
        },
    },
    migrationStrategies: {},
};
